import { render, staticRenderFns } from "./cyberMarketDetail.vue?vue&type=template&id=2a831eae&scoped=true&"
import script from "./cyberMarketDetail.vue?vue&type=script&lang=js&"
export * from "./cyberMarketDetail.vue?vue&type=script&lang=js&"
import style0 from "./cyberMarketDetail.vue?vue&type=style&index=0&id=2a831eae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a831eae",
  null
  
)

export default component.exports